import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const Disclaimer = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-32 pb-20">
      <div className="container mx-auto px-4 md:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="max-w-4xl mx-auto bg-white rounded-xl shadow-sm p-8 md:p-12"
        >
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">Disclaimer</h1>
          <div className="prose prose-lg max-w-none text-gray-600">
            <p className="mb-4">Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">1. Website Information</h2>
            <p>
              The information provided on the ACSE Capital Inc. website is for general informational purposes only. All information on the site is provided in good faith, however, we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any information on the site.
            </p>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">2. No Professional Advice or Financial Services</h2>
            <p>
              The information on our website does not constitute legal, tax, accounting, financing, lending, brokerage, or investment advisory advice and should not be relied upon as such. The content is provided for general informational purposes only.
            </p>
            <p>
              ACSE Capital is not presenting this website as a bank, lender, financier, investment adviser, or financial intermediary. Before making any business, legal, or financial decision, you should consult the appropriate qualified advisers.
            </p>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">3. No Guarantees</h2>
            <p>
              ACSE Capital Inc. does not guarantee any specific results from the use of our website or the information provided therein. The website may contain certain historical information. Historical information is not necessarily current and is provided for your reference only.
            </p>
            <p>
              We reserve the right to modify the contents of this website at any time, but we have no obligation to update any information on our site. You agree that it is your responsibility to monitor changes to our site.
            </p>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">4. Acquisition and Venture Discussions</h2>
            <p>
              Nothing on this website constitutes an offer to lend, finance, broker, underwrite, or arrange financial products. Any acquisition, venture, or business discussion referenced on the site is informational and subject to independent review, diligence, and formal documentation.
            </p>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">5. External Links</h2>
            <p>
              Our website may contain links to external websites that are not provided or maintained by or in any way affiliated with ACSE Capital Inc. Please note that we do not guarantee the accuracy, relevance, timeliness, or completeness of any information on these external websites.
            </p>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">6. Errors and Omissions</h2>
            <p>
              While we strive to keep the information on our website accurate, complete, and up-to-date, we cannot guarantee that there are no errors or omissions. We may make changes to the contents at any time without notice. However, we do not commit to updating the information.
            </p>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">7. Limitation of Liability</h2>
            <p>
              In no event will ACSE Capital Inc., or its directors, employees, or agents be liable to you or any third party for any direct, indirect, consequential, exemplary, incidental, special, or punitive damages, including lost profit, lost revenue, loss of data, or other damages arising from your use of the website, even if we have been advised of the possibility of such damages.
            </p>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">8. Contact Information</h2>
            <p>
              If you have any questions about this Disclaimer, please contact us at <a href="mailto:admin@acsecapital.com" className="text-primary-600 hover:text-primary-700">admin@acsecapital.com</a>.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Disclaimer;
